import axios from 'axios';
import PathManagement from '../common/path-management';
import StatusResponse, { isOk } from '../common/status-response';
import DatatableResponse from '../common/datatable';
import { entityName as carritoEntity } from '../common/entities/cart';
import { decryptResponse } from '../security/cryptojs-aes-format.js';
import { getResponseByUrl, putResponseByUrl } from '../common/xhr';



export interface PlanetPlusArticulo {
  ppa_id: string;
  ppa_artid: string;
  ppa_copete: string;
  ppa_descripcion: string;
  ppa_prioridad: string;
  ppa_puntos: string;
  ppa_vigente_desde: string;
  ppa_vigente_hasta: string;
  ppam_nombre: string;
  ppat_descripcion: string;
  ppai_imagen: string;
}

/**
 * TODO: mover a catalogo
 */
export interface CatalogoFilterOption {
  optionText: string;
  optionValue: string;
  qty: number;
  enabled: boolean;
  selected: boolean;
}

/**
 * TODO: mover a catalogo
 */
export interface CatalogoFilter {
  tipo: string;
  fieldName: string;
  name: string;
  order: string;
  selectedOptions: CatalogoFilterOption[];
  availOptions: CatalogoFilterOption[];
}

/**
 * TODO: mover a catalogo
 */
export interface CatalogoOrder {
  value: string;
  label: string;
}

/**
 * TODO: mover a catalogo
 */
export interface CatalogoHeader {
  cant_item: number;
  /**
   * TODO: tipar
   */
  cant_filter: null;
  page_title: string;
  window_title: string;
  section_description: string;
  section_keywords: string;
}

export interface PlanetPlusData {
  list_item: PlanetPlusArticulo[];
  list_filter: CatalogoFilter[];
  list_order: CatalogoOrder[];
  header: CatalogoHeader;
}

interface PlanetPlusArticuloWS {
  ppa_id: string;
  ppa_artid: string;
  ppa_copete: string;
  ppa_descripcion: string;
  ppa_prioridad: string;
  ppa_puntos: string;
  ppa_vigente_desde: string;
  ppa_vigente_hasta: string;
  ppam_nombre: string;
  ppat_descripcion: string;
  ppai_imagen: string;
}

interface PlanetPlusFiltroWS {
  label: string;
  value: string;
  qty: string;
}

interface PlanetPlusDataWS {
  catalogo: DatatableResponse<PlanetPlusArticuloWS>;
  filtroTipo: PlanetPlusFiltroWS[];
}

export default class PlanetPlusView {

  planetPlusCtaCteData!: PlanetPlusCtaCteData


  async getPlanetPlusData(): Promise<PlanetPlusData | null> {
    const pathManager = new PathManagement();
    const url = pathManager.getPlanetPlus();

    try {
      const response = await axios.get<StatusResponse<PlanetPlusDataWS>>(url, { withCredentials: true });


      if (!isOk(response.data) || !response.data.data) return null;

      // return this.transformPlanetPlusData(decryptResponse(response.data).data);
      return this.transformPlanetPlusData(response.data.data);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de planet plus');
    }

    return null;
  }

  async addToCarrito(ppa_id: string, cantidad: number): Promise<StatusResponse | null> {
    const pathManager = new PathManagement();
    const url = pathManager.getUrlForEntityAction(carritoEntity, 'addPlanetplusArticulo');
    try {

      let dataToPost = {
        productId: ppa_id,
        quantity: cantidad,
        action: 'addPlanetplusArticulo'
      }
      let data = await putResponseByUrl(url, dataToPost);

      return data;
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de planet plus');
    }

    return null;
  }

  async getPlanetPlusCtaCte(): Promise<PlanetPlusCtaCteData> {
    let _pathManager = new PathManagement();
    let url = _pathManager.getPlanetPlusCtaCte();
    try {
      this.planetPlusCtaCteData = await getResponseByUrl(url);
    } catch (err) {
      console.error(err, 'error al intentar recuperar datos de PlanetPlus');
    }

    return this.planetPlusCtaCteData;
  }

  private transformPlanetPlusData(data: PlanetPlusDataWS): PlanetPlusData {
    const typeFilter = this.transformTypeFilter(data.filtroTipo);

    return {
      list_item: data.catalogo.data.map(this.transformPlanetPlusArticulo),
      list_filter: [typeFilter],
      list_order: [],
      header: this.getPlanetPlusHeader(data.catalogo),
    };
  }

  private transformTypeFilter(filters: PlanetPlusFiltroWS[]): CatalogoFilter {
    const typeFilter: CatalogoFilter = {
      tipo: 'tipo',
      fieldName: 'ppa_ppatid',
      name: 'Tipo',
      order: '1',
      availOptions: filters.map((filter) => ({
        optionText: filter.label,
        optionValue: filter.value,
        qty: Number(filter.qty),
        enabled: false,
        selected: false,
      })),
      selectedOptions: [],
    };

    return typeFilter;
  }

  private transformPlanetPlusArticulo(articulo: PlanetPlusArticuloWS): PlanetPlusArticulo {
    return { ...articulo };
  }

  /**
   * TODO: definir los titulos
   */
  private getPlanetPlusHeader(response: DatatableResponse<PlanetPlusArticuloWS>): CatalogoHeader {
    return {
      cant_filter: null,
      cant_item: response.recordsTotal,
      page_title: ' PlanetPlus',
      section_description: 'PlanetPlus',
      section_keywords: '',
      window_title: 'PlanetPlus',
    };
  }
}

export interface PlanetPlusCtaCteData {
  planetPlusCtaCte: any
}
